module.exports = __webpack_public_path__ + "img/match4.cc24621b.jpg";